<template>
  <vx-card no-shadow>
    <div class="mb-base">
      <div class="form">
        <dx-validation-group ref="validation-group">
          <div class="dx-fieldset">
            <div class="dx-field">
              <div class="dx-field-label">
                {{ this.$t("Profile.Company") }}
              </div>
              <DxTextBox class="dx-field-value" :value.sync="localData.company">
              </DxTextBox>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">
                {{ this.$t("Profile.DisplayName") }}
              </div>
              <DxTextBox
                class="dx-field-value"
                :value.sync="localData.displayName"
              >
                <DxValidator>
                  <DxRequiredRule
                    :message="this.$t('Profile.DisplayNameRequired')"
                  />
                </DxValidator>
              </DxTextBox>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">
                {{ this.$t("Profile.FirstName") }}
              </div>
              <DxTextBox
                class="dx-field-value"
                :value.sync="localData.firstName"
              >
                <DxValidator>
                  <DxRequiredRule
                    :message="this.$t('Profile.FirstNameRequired')"
                  />
                </DxValidator>
              </DxTextBox>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">
                {{ this.$t("Profile.LastName") }}
              </div>
              <DxTextBox
                class="dx-field-value"
                :value.sync="localData.lastName"
              >
                <DxValidator>
                  <DxRequiredRule
                    :message="this.$t('Profile.LastNameRequired')"
                  />
                </DxValidator>
              </DxTextBox>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">
                {{ this.$t("Profile.Street") }}
              </div>
              <DxTextBox class="dx-field-value" :value.sync="localData.street">
                <DxValidator>
                  <DxRequiredRule :message="$t('Profile.StreetRequired')" />
                </DxValidator>
              </DxTextBox>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">
                {{ this.$t("Profile.HouseNumber") }}
              </div>
              <DxNumberBox
                class="dx-field-value"
                :value.sync="localData.houseNumber"
              >
                <DxValidator>
                  <DxRangeRule
                    :max="999999"
                    :min="1"
                    message="$t('HouseNumberRequired')"
                  />
                </DxValidator>
              </DxNumberBox>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">
                {{ this.$t("Profile.HouseNumberAddition") }}
              </div>
              <DxTextBox
                class="dx-field-value"
                :value.sync="localData.houseNumberAddition"
              />
            </div>
            <div class="dx-field">
              <div class="dx-field-label">
                {{ this.$t("Profile.PostalCode") }}
              </div>
              <DxTextBox
                class="dx-field-value"
                :value.sync="localData.postalCode"
              >
                <DxValidator>
                  <DxRequiredRule
                    :message="this.$t('Profile.PostcalCodeRequired')"
                  />
                </DxValidator>
              </DxTextBox>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">
                {{ this.$t("Profile.City") }}
              </div>
              <DxTextBox class="dx-field-value" :value.sync="localData.city">
                <DxValidator>
                  <DxRequiredRule :message="this.$t('Profile.CityRequired')" />
                </DxValidator>
              </DxTextBox>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">
                {{ $t("Profile.Country") }}
              </div>
              <div class="dx-field-value">
                <DxSelectBox
                  :items="countries"
                  :search-enabled="true"
                  :value.sync="localData.idCountry"
                  display-expr="name"
                  value-expr="id"
                >
                  <DxValidator>
                    <DxRequiredRule
                      :message="this.$t('Profile.CountryRequired')"
                    />
                  </DxValidator>
                </DxSelectBox>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">
                {{ $t("Profile.Language") }}
              </div>
              <div class="dx-field-value">
                <DxSelectBox
                  :items="languages"
                  :search-enabled="true"
                  :value.sync="localData.language"
                  display-expr="description"
                  value-expr="code"
                >
                  <DxValidator>
                    <DxRequiredRule
                      :message="this.$t('Profile.LanguageRequired')"
                    />
                  </DxValidator>
                </DxSelectBox>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">
                {{ this.$t("Profile.VatNumber") }}
              </div>
              <DxTextBox
                class="dx-field-value"
                :value.sync="localData.vatNumber"
              >
              </DxTextBox>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">
                {{ $t("Profile.VatExemption") }}
              </div>
              <div class="dx-field-value">
                <DxCheckBox :value="localData.vatExemption" />
              </div>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end mt-base">
            <vs-button
              @click="saveChanges"
              class="float-right px-4 w-full md:w-auto mt-6"
              >{{ this.$t("Save") }}</vs-button
            >
          </div>
        </dx-validation-group>
      </div>
    </div>
  </vx-card>
</template>
<script>
import DxTextBox from 'devextreme-vue/text-box'
import DxButton from 'devextreme-vue/button'
import { DxSelectBox } from 'devextreme-vue/select-box'
import { DxNumberBox } from 'devextreme-vue/number-box'
import { DxCheckBox } from 'devextreme-vue/check-box';
import DxValidationGroup from 'devextreme-vue/validation-group'
import DxValidationSummary from 'devextreme-vue/validation-summary'
import {
  DxValidator,
  DxRequiredRule,
  DxRangeRule,
  DxCompareRule,
  DxStringLengthRule,
} from 'devextreme-vue/validator'
import { notifyMixin } from '@/mixins/notifyMixin'
import moduleRefcodes from '@/store/refcodes/moduleRefCodes.js'
export default {
  mixins: [notifyMixin],
  data () {
    return {
      localData: {},
      countries: []
    }
  },
  components: {
    DxTextBox,
    DxSelectBox,
    DxNumberBox,
    DxCheckBox,
    DxButton,
    DxValidator,
    DxRequiredRule,
    DxCompareRule,
    DxRangeRule,
    DxStringLengthRule,
    DxValidationSummary,
    DxValidationGroup
  },
  created () {
    if (!moduleRefcodes.isRegistered) {
      this.$store.registerModule('refcodes', moduleRefcodes)
      moduleRefcodes.isRegistered = true
    }
    this.fetchData()
  },
  computed: {
    languages () {
      return this.$store.state.refCodes.languages.map(a => {
        return { ...a, description: this.$t(`LanguageList.${a.description}`) }
      })
    },
  },
  methods: {
    fetchData () {
      this.$store.dispatch('auth/fetchProfile')
        .then(res => {
          this.localData = res.data.profile
          Promise.all([
            this.fetchCountries(),
          ])
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignNotFound = true
            return
          }
          console.error(err)
        })
    },
    fetchCountries () {
      this.$store.dispatch('refcodes/fetchCountries')
        .then(res => {
          this.countries = res.data.items
        })
    },
    saveChanges () {
      const validationGroup = this.$refs["validation-group"].instance
      const result = validationGroup.validate()
      if (result.isValid) {
        this.$vs.loading()
        const payload = {
          id: this.$store.state.AppActiveUser.uid,
          ...this.localData
        }
        this.$store
          .dispatch(
            'auth/updateProfile',
            payload
          )
          .then(() => {
            this.notifySuccess(this.$t("Profile.ProfileUpdated"))
            this.$vs.loading.close()
          })
          .catch((error) => {
            const errorMessage = this.$t(`Profile.${error.response.statusText}`)
            this.notifyError(errorMessage)
            this.$vs.loading.close()
          })

      }
    }
  }
}
</script>